export default "__VITE_ASSET__BL1$pgou__"